// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wdr-toolbar li {
  margin: 0 6px !important;
}

.wdr-toolbar li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
  height: 60px;
  color: var(--color-text);
  transition: color 0.3s, background-color 0.3s;
}

.wdr-toolbar li a:hover {
  color: var(--color-primary);
  background-color: var(--color-accent);
}

.wdr-svg-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.wdr-svg-icon svg {
  display: none;
}

.wdr-toolbar li span {
  font-size: 12px;
  line-height: 1;
  color: var(--color-text-muted);
}

#wdr-tab-save {
  display: none !important;
}

/* Font Awesome */
.wdr-svg-icon::before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  font-size: 20px;
  color: var(--color-primary);
}

#wdr-tab-connect .wdr-svg-icon::before { content: "\\f0c1"; }
#wdr-tab-open .wdr-svg-icon::before { content: "\\f15b"; }
#wdr-tab-export .wdr-svg-icon::before { content: "\\f019"; }
#wdr-tab-format .wdr-svg-icon::before { content: "\\f0ea"; }
#wdr-tab-options .wdr-svg-icon::before { content: "\\f013"; }
#wdr-tab-fullscreen .wdr-svg-icon::before { content: "\\f065"; }
#wdr-tab-fields .wdr-svg-icon::before { content: "\\f0db"; }

.wdr-row {
  color: var(--color-text) !important;
}

.wdr-cell {
  color: var(--color-text) !important;
}

.wdr-header {
  background-color: var(--color-bg-secondary) !important;
  color: var(--color-text);
}

.wdr-ui-btn {
  color: var(--color-primary) !important;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  transition: background-color 0.3s, color 0.3s;
}

.wdr-ui-btn:hover {
  background-color: var(--color-accent);
}

#wdr-btn-apply {
  background-color: var(--color-primary);
  color: var(--accent-color-color);
}

#wdr-tab-connect {
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/pivot/Pivot.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,yCAAyC,gBAAgB,EAAE;AAC3D,sCAAsC,gBAAgB,EAAE;AACxD,wCAAwC,gBAAgB,EAAE;AAC1D,wCAAwC,gBAAgB,EAAE;AAC1D,yCAAyC,gBAAgB,EAAE;AAC3D,4CAA4C,gBAAgB,EAAE;AAC9D,wCAAwC,gBAAgB,EAAE;;AAE1D;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sDAAsD;EACtD,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".wdr-toolbar li {\n  margin: 0 6px !important;\n}\n\n.wdr-toolbar li a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 4px;\n  height: 60px;\n  color: var(--color-text);\n  transition: color 0.3s, background-color 0.3s;\n}\n\n.wdr-toolbar li a:hover {\n  color: var(--color-primary);\n  background-color: var(--color-accent);\n}\n\n.wdr-svg-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.wdr-svg-icon svg {\n  display: none;\n}\n\n.wdr-toolbar li span {\n  font-size: 12px;\n  line-height: 1;\n  color: var(--color-text-muted);\n}\n\n#wdr-tab-save {\n  display: none !important;\n}\n\n/* Font Awesome */\n.wdr-svg-icon::before {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  font-size: 20px;\n  color: var(--color-primary);\n}\n\n#wdr-tab-connect .wdr-svg-icon::before { content: \"\\f0c1\"; }\n#wdr-tab-open .wdr-svg-icon::before { content: \"\\f15b\"; }\n#wdr-tab-export .wdr-svg-icon::before { content: \"\\f019\"; }\n#wdr-tab-format .wdr-svg-icon::before { content: \"\\f0ea\"; }\n#wdr-tab-options .wdr-svg-icon::before { content: \"\\f013\"; }\n#wdr-tab-fullscreen .wdr-svg-icon::before { content: \"\\f065\"; }\n#wdr-tab-fields .wdr-svg-icon::before { content: \"\\f0db\"; }\n\n.wdr-row {\n  color: var(--color-text) !important;\n}\n\n.wdr-cell {\n  color: var(--color-text) !important;\n}\n\n.wdr-header {\n  background-color: var(--color-bg-secondary) !important;\n  color: var(--color-text);\n}\n\n.wdr-ui-btn {\n  color: var(--color-primary) !important;\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.wdr-ui-btn:hover {\n  background-color: var(--color-accent);\n}\n\n#wdr-btn-apply {\n  background-color: var(--color-primary);\n  color: var(--accent-color-color);\n}\n\n#wdr-tab-connect {\n  color: var(--color-primary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
